import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui";

/**
 * 404 fallback. Without this, an unmatched URL renders nothing — the
 * user sees a blank screen with no obvious way back to the app. Most
 * common cause is a deep-link to a deleted/renamed contact, list, or
 * automation.
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-[calc(100vh-3rem)] items-center justify-center p-8">
      <div className="max-w-sm text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-zinc-800/60 text-zinc-400">
          <Compass className="h-5 w-5" />
        </div>
        <h1 className="mt-4 text-lg font-semibold text-zinc-100">Page not found</h1>
        <p className="mt-2 text-sm text-zinc-500">
          The page you were looking for doesn't exist, or it may have been moved.
        </p>
        <div className="mt-5">
          <Link to="/">
            <Button size="sm">Back to dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
